import { types as t, Instance, IAnyStateTreeNode, applySnapshot, detach, isAlive } from 'mobx-state-tree';
import { getIdentifier } from '~/mst/utils';
import views from './collection_views';

const CollectionMapFactory = (modelType) =>
  t
    .model({
      models: t.map(modelType)
    })
    .actions((self) => {
      function detachModels() {
        if (isAlive(self.models)) {
          detach(self.models);
        }
      }
      return {
        detach() {
          detachModels();
        },
        add(model: IAnyStateTreeNode) {
          self.models.put(model);
          return model;
        },
        remove(model: IAnyStateTreeNode) {
          detach(model);
          self.models.delete(getIdentifier(model)!);
        },
        update(model: IAnyStateTreeNode) {
          self.models.delete(getIdentifier(model)!);
          self.models.put(model);
        },
        reset() {
          detachModels();
          applySnapshot(self, { models: {} });
        }
      };
    })
    .views((self) => ({
      get toArray() {
        return Array.from(self.models.values());
      }
    }))
    .views(views);

type CollectionMap = ReturnType<typeof CollectionMapFactory>;
export interface ICollectionMap extends Instance<CollectionMap> {}

export default CollectionMapFactory;
